<div class="el-breadcrumb-wrapper">
  <div class="container ">
    <div class="el-breadcrmb-inner py-2 ">
      <h4>eBook:-{{BookName}}</h4>

    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="ChapterList.length>0">

  <div class="row">
    <div class="col-md-3">

      <div class="book-chapter">

        <h3><strong>Chapters</strong></h3>
        <hr>
        <ul>
          <li *ngFor="let chapter of ChapterList; let i = index" [class.active]="i === activeChapterIndex"
            (click)="loadChapter(i)">

            <span [innerHTML]="chapter.ChapterName"></span>
             

          </li>
        </ul>
      </div>


    </div>
    <div class="col-md-9">
      <iframe class="iframe_book" *ngIf="selectedChapterUrl" [src]="selectedChapterUrl" frameborder="0" allowfullscreen>
      </iframe>

      <div *ngIf="!selectedChapterUrl" class="no-data">
        ❌ Chapter Not Available
      </div>
    </div>
  </div>

</div>

<!-- Breadcrumb Start -->


<div class="el-blog-single-wrapper el-blog-medium-wrapper pt-4" *ngIf="ChapterList.length==0">
  <div class="container">
    <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper">
      <div class="col-md-12 pdf-container" (contextmenu)="disableRightClick($event)">
        <ngx-extended-pdf-viewer [zoom]="zoom" [pageViewMode]="pageViewMode" [src]="selectedPdf"
          style="width: 100%; display: block;" [textLayer]="false" [ignoreKeyboard]="true"
          [ignoreKeys]="['CTRL+S','CTRL+SHIFT+S','S','SHIFT+S']" [replaceBrowserPrint]="false"
          [showSidebarButton]="true" [showFindButton]="false" [showPrintButton]="false" [showDownloadButton]="false"
          [showOpenFileButton]="false" [showZoomButtons]="true" [showStampEditor]="false" [showBorders]="false"
          [showPresentationModeButton]="false" [showRotateButton]="false" [showHandToolButton]="false"
          [showSpreadButton]="false" [showPropertiesButton]="false" [showSecondaryToolbarButton]="true"
          [enablePrint]="false" (contextmenu)="disableRightClick($event)">
        </ngx-extended-pdf-viewer>

        <div class=" overlay">
        </div>
      </div>
    </div>
  </div>
</div>